module.exports = __webpack_public_path__ + "img/plane.fac603ac.svg";